import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { startloadProductos } from '../../../app/store/catalagos/thunks';
import { SearchProd } from './panels/SearchProd';
import { Minus, Plus, Save, Search, Slash, Trash2 } from 'react-feather';
import { useState } from 'react';
import Swal from 'sweetalert2';
import { useForm } from 'react-hook-form';
import { SearchCliente } from '../orderNew/modals/SearchCliente';
import { searchClientes } from '../../../app/store/clientes/thunks';
import { closeSales, startRegistroDetailInd, startVentaProductos } from '../../../app/store/ordenes/thunks';

import { AddFacturacion } from '../customers/modals/AddFacturacion';
import { SearchFacturacion } from '../orderClose/modals/SearchFacturacion';
import { SaleSpecial } from './panels/SaleSpecial';
import { NewCustomer } from '../customers/modals/NewCustomer';
import { CardCobroVenta } from './shared/CardCobroVenta';
import { SaleSpecial_r } from './panels/SaleSpecial_r';
import { SaleByOrder_r } from './panels/SaleByOrder_r';

export const Sales = () => {
  const dispatch = useDispatch();
  const { descuentos, tipos_pagos, servicios, productosAlm, isLoading } = useSelector(state => state.catalogos);
  const { empleados } = useSelector(state => state.empleados);
  const { facturacion, facturacion_edit } = useSelector(state => state.facturacion);
  const { usuario, id_emp } = useSelector(state => state.usuario);
  const { cliente_edit, status } = useSelector(state => state.clientes);

  const capturante = usuario;

  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
    didOpen: (toast) => {
      // toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  });

  const { register, reset, formState: { errors }, handleSubmit } = useForm({ defaultValues: { textSearch: "", param: "1" } });
  const { register: registerCC, trigger: triggerCC, setFocus: setFocusCC, getValues: getValuesCC, watch: watchCC, setValue: setValueCC, formState: { errors: errorsCC }, handleSubmit: handleSubmitCC, reset: resetCC } = useForm(
    { mode: 'all', defaultValues: {} });

  useEffect(() => {
    dispatch(startloadProductos());
  }, []);


  const handledSearch = (data) => {
    dispatch(searchClientes(data))
  }

  const [ProductosCompra, setProductosCompra] = useState([]);

  const handledAddProduct = (e) => {

    let producto = ProductosCompra.filter(item => item.ID == e);
    if (producto.length === 0) {

      const result = productosAlm.filter(item => item.ID == e)[0];
      let servicioProd = ProductosCompra.filter(item => item.producto_id == result.ID)
      // console.log(result);
      if (servicioProd == 0) {
        Toast.fire({
          icon: 'success',
          title: 'Producto Agregado a la lista'
        });

        let sol = {
          "ID": result.ID,
          "SKU": result.SKU,
          "NOMBRE": result.NAME_PRODUCT,
          "DESCRIPCION": result.DESCRIPTION_PRODUCT,
          "COSTO_PUBLICO": result.SALE_PRICE,
          "EXISTENCIA": result.CURRENTSTOCK,
          "CANTIDAD": 1,
          "ACUMULADO": 1 * Number(result.SALE_PRICE),
          "VENTA_ESPECIAL": 0,
        }
        setProductosCompra([...ProductosCompra, sol]);
      } else {
        Toast.fire({
          icon: 'error',
          title: 'Ese producto ya fue agregado al listado'
        });
      }
    }
  }

  useEffect(() => {
    if (facturacion_edit.length != 0) {
      setValueCC('id_facturacion', facturacion_edit.ID);
      setValueCC('rfc_factruracion', facturacion_edit.RFC);
      setValueCC('razon_soc_facturacion', facturacion_edit.RAZON_SOCIAL);
      setValueCC('regimen_facturacion', facturacion_edit.REGIMEN_FISCAL);
      setValueCC('telefono_facturacion', facturacion_edit.TELEFONO);
      setValueCC('correo_facturacion', facturacion_edit.CORREO);
      setValueCC('direccion_facturacion', facturacion_edit.DIRECCION + ', CP:' + facturacion_edit.COD_POSTAL);
      setValueCC('cp_facturacion', facturacion_edit.COD_POSTAL);
    }

  }, [facturacion_edit]);

  // Get data hijo
  const [datosCobro, setDatosCobro] = useState({
    pagos: [],
    productos: [],
    iva: 0,
    total: 0,
    totalPagado: 0,
    subtotal: 0,
    cambio: 0,
    faltante: 0,
    typeSale: 0
  });

  const handleUpdateCobro = (data) => {
    if (data.productos) {
      setProductosCompra(data.productos);
    }
    setDatosCobro(prev => ({ ...prev, ...data }));
  };


  const cancelSale = () => {
    window.location.reload();
  }


  const closeSale = () => {

    let idCliente = cliente_edit.length !== 0 ? cliente_edit.ID : 1;

    let idFacturacion = getValuesCC('id_facturacion');
    let flagFacturacion = 0;

    const div = document.getElementById("facturacion_div_sales");
    if (div && div.style.display === 'block') {
      flagFacturacion = 1;
    }

    if (idFacturacion == undefined || idFacturacion == "") idFacturacion = 0;

    const { pagos, productos, total, totalPagado, subtotal, faltante, iva, cambio } = datosCobro;

    if (productos.length === 0) {
      Toast.fire({ icon: 'error', title: 'Debe agregar productos, para la venta.' });
      return;
    }

    if (faltante > 0) {
      Toast.fire({ icon: 'error', title: 'Debe realizar el cobro correspondiente para la venta.' });
      return;
    }

    let flagSpecial = 0; let costoHDL = 0; let tecnico = 0;
    productos.forEach(item => {

      if (item.VENTA_ESPECIAL === 0) {
        tecnico = watchCC('tecnico');
      }

      if (item.VENTA_ESPECIAL === 1) {
        flagSpecial = 1;
        costoHDL = item.costoHDL;
        tecnico = item.tecnico;
      }
      if (item.VENTA_ESPECIAL === 2) {
        flagSpecial = 2;
        costoHDL = item.costoHDL;
        tecnico = item.tecnico;
      }
    });





    const payload = {
      idCliente: idCliente,
      idFacturacion: idFacturacion,
      flagFacturacion: flagFacturacion,
      flagSpecial: flagSpecial,
      capturo: capturante,
      total: total,
      iva: iva,
      subtotal: subtotal,
      pagado: totalPagado,
      cambio: cambio,
      detailPagos: pagos,
      productos: productos,
      costohdl: costoHDL,
      tecnico: tecnico,
      idcapturo: id_emp
    };

    console.log(payload);


    const confirmMsg = flagFacturacion
      ? `Está por realizar una venta. No se han indicado los datos para realizar la facturacion correspondiente. (Puede ir al menu Facturacion, seccion pendientes a indicarlos, ya que se haya terminado la venta). ¿Desea continuar?`
      : `Está por realizar una venta. ¿Desea continuar?`;

    Swal.fire({
      title: 'Atención',
      text: confirmMsg,
      icon: 'warning',
      showCancelButton: true,
      showCancelButton: true, confirmButtonText: 'Si, continuar', cancelButtonText: 'No, cancelar',
      customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-secondary ms-2' }, buttonsStyling: false
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(closeSales(payload));
      }
    });

  }

  const showDivFacturacion = (e) => {
    document.getElementById("facturacion_div_sales").style.display = "block";
  }

  const HideDivFacturacion = (e) => {
    document.getElementById("facturacion_div_sales").style.display = "none";
    setValueCC('id_facturacion', "");
    setValueCC('rfc_factruracion', "");
    setValueCC('razon_soc_facturacion', "");
    setValueCC('regimen_facturacion', "");
    setValueCC('telefono_facturacion', "");
    setValueCC('correo_facturacion', "");
    setValueCC('direccion_facturacion', "");
    setValueCC('cp_facturacion', "");
  }

  // Manejo de tabs
  const [activeTab, setActiveTab] = useState("catalogo");

  const handleTabChange = (tab) => {
    if (activeTab === "catalogo" && ProductosCompra.length > 0) {
      Swal.fire({
        title: "Atencion",
        text: "Esta por cambiar el tipo de venta... ¿Desea continuar?",
        icon: "warning",
        showCancelButton: true,
        showCancelButton: true, confirmButtonText: 'Si, continuar', cancelButtonText: 'No, cancelar',
        customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-secondary ms-2' }, buttonsStyling: false
      }).then((result) => {
        if (result.isConfirmed) {
          setProductosCompra([]); // limpiar
          setDatosCobro({ pagos: [], productos: [], iva: 0, total: 0, totalPagado: 0, subtotal: 0, cambio: 0, faltante: 0 });
          setActiveTab(tab); // cambiar de tab
        }
      });
    } else if (activeTab === "especial" && datosCobro.productos.length > 0) {
      Swal.fire({
        title: "Atencion",
        text: "Esta por cambiar el tipo de venta... ¿Desea continuar?",
        icon: "warning",
        showCancelButton: true,
        showCancelButton: true, confirmButtonText: 'Si, continuar', cancelButtonText: 'No, cancelar',
        customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-secondary ms-2' }, buttonsStyling: false
      }).then((result) => {
        if (result.isConfirmed) {
          setProductosCompra([]);
          setDatosCobro({ pagos: [], productos: [], iva: 0, total: 0, totalPagado: 0, subtotal: 0, cambio: 0, faltante: 0 });
          setActiveTab(tab);
        }
      });
    } else if (activeTab === "pedido" && datosCobro.productos.length > 0) {
      Swal.fire({
        title: "Atencion",
        text: "Esta por cambiar el tipo de venta... ¿Desea continuar?",
        icon: "warning",
        showCancelButton: true,
        showCancelButton: true, confirmButtonText: 'Si, continuar', cancelButtonText: 'No, cancelar',
        customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-secondary ms-2' }, buttonsStyling: false
      }).then((result) => {
        if (result.isConfirmed) {
          setProductosCompra([]);
          setDatosCobro({ pagos: [], productos: [], iva: 0, total: 0, totalPagado: 0, subtotal: 0, cambio: 0, faltante: 0 });
          setActiveTab(tab);
        }
      });
    }
    else {
      setActiveTab(tab);
    }
  };


  return (
    <>
      <SearchCliente /> <NewCustomer />
      <div className='row'>
        <h1 className="h4 mb-3 fw-bold">Venta productos</h1>

        <div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-3'>
          <div className="card ">
            <div className="card-body">
              <form
                onSubmit={handleSubmit(handledSearch)}
              >
                <div className='mb-2'>
                  <label className="mb-1 text-dark">Buscar por:</label>
                  <div className="d-flex">
                    <select className="form-select w-50 me-1"
                    // {...register("param")}
                    >
                      <option value='1'>NOMB.</option>
                      <option value='0'>CVE.</option>

                      <option value='2'>TEL.</option>
                      <option value='3'>CEL.</option>
                    </select>
                    <input className="form-control me-2" type="search" aria-label="Search" autoComplete='off'
                      {...register("textSearch", { required: 'Introduce termino a buscar' })}
                    />
                    <button className="btn btn-outline-secondary" type="submit" data-bs-toggle="modal" data-bs-target="#searchCustomer">
                      <Search size="20" />
                    </button>
                  </div>
                </div>
              </form>
              <a className="link " data-bs-toggle="modal" data-bs-target="#newCliente">Agregar Nuevo Cliente</a>
            </div>

            {
              status == 'CLIENTE_ENCONTRADO' ?
                <>
                  <AddFacturacion /> <SearchFacturacion />
                  <hr className="my-0" />
                  <div className="card-body">
                    <div className="row mb-1">
                      <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8">
                        <h5 className="fw-bold me-2 border-0">Datos del Cliente:  </h5>
                      </div>
                      <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-end">
                      </div>
                    </div>
                    <hr className="my-0" />
                    <div className="row">
                      <div className="col-12 mt-3">
                        <div className="mb-1">
                          <label className="form-label">Nombre:</label>
                          <input type="text" className="form-control" disabled value={cliente_edit.NOMBRE} />
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="mb-1">
                          <label className="form-label">Telefono:</label>
                          <input type="text" className="form-control" disabled value={cliente_edit.TELEFONO} />
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="mb-1">
                          <label className="form-label">Celular:</label>
                          <input type="text" className="form-control" disabled value={cliente_edit.CELULAR} />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="mb-3">
                          <label className="form-label">Correo electronico:</label>
                          <input type="text" className="form-control" disabled value={cliente_edit.EMAIL} />
                        </div>
                      </div>
                      <div className="col-12 text-center">
                        {
                          cliente_edit.TIPO_CLIENTE == 1 ?
                            <>
                              <div className="fw-bold align-middle">
                                <span > Nivel: {cliente_edit.CLAS_CLIENTE} </span>
                              </div>
                            </> : <div className="fw-bold align-middle">
                              <span > Nivel: {cliente_edit.CLAS_CLIENTE} </span>
                            </div>
                        }
                      </div>
                      <div className="col-12 mt-2">

                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="requierofacura" id="inlineRadio1" value="0" defaultChecked onClick={e => HideDivFacturacion(e)} />
                          <label className="form-check-label" >No, requiero factura</label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="requierofacura" id="inlineRadio2" value="1" onClick={e => showDivFacturacion(e)} />
                          <label className="form-check-label" >Si, requiero factura</label>
                        </div>
                      </div>

                      <div id="facturacion_div_sales" className="col-12 mt-4" style={{ display: "none" }}>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                          <h5 className="fw-bold  border-0">Datos de facturación </h5>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 text-start mb-1">
                          <button type="button" className="btn btn-outline-dark border-0" data-bs-toggle="modal" data-bs-target="#newFacturacion">
                            <Plus size='20' />
                          </button>
                          <button type="button" className="btn btn-outline-dark border-0" data-bs-toggle="modal" data-bs-target="#searchFacturacion">
                            <Search size='20' />
                          </button>
                        </div>
                        <hr className="my-0" />
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl123 col-xxl-12 mt-2">
                          <input type="hidden" className="form-control"
                            disabled  {...registerCC("id_facturacion")}
                          />
                          <div className="mb-1">
                            <label className="form-label">RFC:</label>
                            <input type="text" className="form-control"
                              disabled {...registerCC("rfc_factruracion")}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                          <div className="mb-1">
                            <label className="form-label">Razon Social:</label>
                            <input type="text" className="form-control"
                              {...registerCC("razon_soc_facturacion")} disabled
                            />
                          </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                          <div className="mb-1">
                            <label className="form-label">Regimen:</label>
                            <input type="text" className="form-control"
                              {...registerCC("regimen_facturacion")} disabled
                            />
                          </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                          <div className="mb-1">
                            <label className="form-label">Telefono:</label>
                            <input type="text" className="form-control"
                              {...registerCC("telefono_facturacion")} disabled
                            />
                          </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                          <div className="mb-1">
                            <label className="form-label">Correo Electronico:</label>
                            <input type="text" className="form-control"
                              {...registerCC("correo_facturacion")} disabled
                            />
                          </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                          <div className="mb-2">
                            <label className="form-label">Dirección:</label>
                            <textarea className="form-control" rows="4"
                              {...registerCC("direccion_facturacion")} disabled
                            ></textarea>
                          </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 col-xxl-5">
                          <div className="mb-1">
                            <label className="form-label">CP:</label>
                            <input type="text" className="form-control"
                              {...registerCC("cp_facturacion")} disabled
                            />
                          </div>
                        </div>

                      </div>


                    </div>
                  </div>
                </> : <></>
            }
          </div>
        </div>

        <div className='col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-9'>
          <div className="card">

            <div className="card-body">

              <ul className="nav nav-pills mb-2">
                <li className="nav-item">
                  <button className={`nav-link ${activeTab === "catalogo" ? "active" : ""}`} onClick={() => handleTabChange("catalogo")} > Catálogo | Productos </button>
                </li>
                <li className="nav-item">
                  <button className={`nav-link ${activeTab === "especial" ? "active" : ""}`} onClick={() => handleTabChange("especial")}> Venta Especial </button>
                </li>
                <li className="nav-item">
                  <button className={`nav-link ${activeTab === "pedido" ? "active" : ""}`} onClick={() => handleTabChange("pedido")}> Venta por pedido </button>
                </li>
              </ul>
              <hr className='my-0' />
              <div className="tab-content">
                {
                  activeTab === "catalogo" && (
                    <>
                      <SearchProd handledAddProduct={handledAddProduct} />
                      <div className='row p-3'>
                        <div className='col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-8 mb-2'>
                          <label className="form-label">Tecnico asignado:</label>
                          <select className="form-select " defaultValue={'0'}  {...registerCC("tecnico")} >
                            <option value={'0'} >Ninguno</option>
                            {
                              empleados.map((item, index) => (
                                item.ESTADO == 1 && item.ROL_ID == 3 ? <option key={index} value={item.ID} className='text-uppercase' >({item.USER}) | {item.NOMBRE} </option>
                                  : <option key={index} style={{ display: "none" }} ></option>
                              ))
                            }
                          </select>
                        </div>
                      </div>
                      <CardCobroVenta listProducts={ProductosCompra} listPaymentMethods={tipos_pagos} onUpdate={handleUpdateCobro} precioIncluyeIVA={true} />
                    </>
                  )}
                {
                  activeTab === "especial" && (
                    <SaleSpecial_r onUpdate={handleUpdateCobro} />
                  )}
                {
                  activeTab === "pedido" && (
                    <SaleByOrder_r onUpdate={handleUpdateCobro} />
                  )}
              </div>

              <div className="text-end">
                <button type="button" className="btn btn-outline-danger mt-2" onClick={cancelSale}><Slash size='20' /> Cancelar </button>
                <button type="submit" className="btn btn-outline-primary mt-2 ms-3" onClick={closeSale}>
                  <Save size='20' /> Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}
